<template>
  <div class="container d-flex justify-content-center">
    <b-col md="8" cols="12">
      <step-progress
        :steps="mySteps"
        :current-step="step"
        :active-thickness="1"
        :passive-thickness="1"
        :line-thickness="4"
      ></step-progress>
    </b-col>
  </div>
</template>

<script>
import StepProgress from "vue-step-progress";
export default {
  name: "StepProgress",
  components: {
    "step-progress": StepProgress,
  },

  props: {
    currentStep: { type: Number, default: 0 },
    mySteps: {
      type: Array,
      default: function () {
        return ["Step 1", "Step 2", "Step 3"];
      },
    },
  },
  data() {
    return {};
  },

  computed: {
    step() {
      return this.currentStep >= 0 ? this.currentStep : 0;
    },
  },

  watch: {
    currentStep(count) {
      this.$emit("checkCurrentStep", this.currentStep);
    },
  },
};
</script>
<style>
.step-progress__wrapper {
  z-index: 0 !important;
}
.step-progress__step span {
  display: none !important;
}
.step-progress__step:after {
  background-color: var(--grey-border) !important;
  border: var(--grey-border) !important;
  height: 15px !important;
  width: 15px !important;
}
.step-progress__step--active:after {
  background-color: var(--blue-medium) !important;
}
.step-progress__step--valid:after {
  background-color: var(--blue-medium) !important;
}
.step-progress__wrapper-after {
  background-color: var(--blue-medium) !important;
}
.step-progress__wrapper-before {
  background-color: var(--grey-border) !important;
}
.step-progress__step-label {
  color: var(--grey-border);
  font-size: 14px !important;
  font-weight: 400 !important;
}
.step-progress__step--valid .step-progress__step-label {
  color: var(--blue-medium) !important;
}
.step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: var(--blue-medium) !important;
}
</style>
